import type { SelfSignUpForm } from '../types';
import { getRequiredFields } from './planConfig';

export type Steps = 'restaurant_info_step' | 'sign_up_step' | 'site_info_step' | 'summary_step';

const validateStep = (step: Steps, formValues: SelfSignUpForm, productPlan?: string): boolean => {
  const requirements = getRequiredFields(productPlan, step);

  return Object.entries(requirements).every(([key, requirement]) => {
    const fieldValue = formValues[key as keyof SelfSignUpForm];

    if (typeof requirement === 'object' && requirement !== null) {
      if (typeof fieldValue !== 'object' || fieldValue === null) {
        return false;
      }

      return Object.entries(requirement).every(([subKey, isRequired]) => {
        if (!isRequired) return true;
        return Boolean((fieldValue as Record<string, unknown>)[subKey]);
      });
    }

    return Boolean(fieldValue);
  });
};

export { validateStep };
